export default __webpack_public_path__ + "static/media/ic_close_black_24px.f005b782.svg";